import { render, staticRenderFns } from "./EntryHistoryRestore.vue?vue&type=template&id=f8b64132&scoped=true"
import script from "./EntryHistoryRestore.vue?vue&type=script&lang=js"
export * from "./EntryHistoryRestore.vue?vue&type=script&lang=js"
import style0 from "./EntryHistoryRestore.vue?vue&type=style&index=0&id=f8b64132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b64132",
  null
  
)

export default component.exports